/* DUNEZ - eigenes Verhalten. Neue Datei, keine Horizon-Kerndatei.

   1) Mobiles Menue schliesst sich bei Anker-Links auf derselben Seite.
   2) Produktgalerie zeigt nur die Bilder der gewaehlten Farbe.
   3) Cookie-Einstellungen oeffnen das Banner statt auf 404 zu laufen.
*/

(function () {
  'use strict';

  /* ----------------------------------------------------------------
     1 - MOBILES MENUE
     ---------------------------------------------------------------- */

  var HEADER_SELECTOR = 'header, .header, .header-wrapper, [class*="header"], [id*="header"]';

  function findExpandedToggle() {
    var candidates = document.querySelectorAll('[aria-expanded="true"]');
    var fallback = null;
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.offsetParent === null && el.getClientRects().length === 0) continue;
      if (el.closest && el.closest(HEADER_SELECTOR)) return el;
      if (!fallback) fallback = el;
    }
    return fallback;
  }

  function findOpenSummary(link) {
    var node = link.parentElement;
    while (node && node !== document.body) {
      if (node.tagName === 'DETAILS' && node.open) {
        var summary = node.querySelector('summary');
        if (summary) return summary;
      }
      node = node.parentElement;
    }
    return null;
  }

  function hardCloseAncestors(link) {
    var node = link.parentElement;
    while (node && node !== document.body) {
      if (node.tagName === 'DIALOG' && node.open) {
        try { node.close(); } catch (e) { node.removeAttribute('open'); }
      } else if (node.tagName === 'DETAILS' && node.open) {
        node.open = false;
      } else if (node.hasAttribute && node.hasAttribute('open')) {
        node.removeAttribute('open');
      }
      node = node.parentElement;
    }
  }

  function isInsideOverlay(link) {
    var node = link.parentElement;
    while (node && node !== document.body) {
      if (node.tagName === 'DIALOG' && node.open) return true;
      if (node.tagName === 'DETAILS' && node.open) return true;
      if (node.hasAttribute && node.hasAttribute('open')) return true;
      node = node.parentElement;
    }
    return false;
  }

  function closeMenu(link) {
    var toggle = findExpandedToggle();
    if (toggle) { toggle.click(); return; }

    var summary = findOpenSummary(link);
    if (summary) { summary.click(); return; }

    document.dispatchEvent(
      new KeyboardEvent('keydown', { key: 'Escape', code: 'Escape', keyCode: 27, bubbles: true })
    );
    window.setTimeout(function () { hardCloseAncestors(link); }, 60);
  }

  /* ----------------------------------------------------------------
     3 - COOKIE-EINSTELLUNGEN

     Horizon verlinkt die Cookie-Einstellungen auf /policies/ mit dem
     Anker #shopifyReshowConsentBanner. Der Anker ist richtig, die
     Basis-URL nicht: /policies/ existiert in Shopify nicht und liefert
     eine 404. Wir fangen den Klick ab und oeffnen das Banner direkt
     auf der aktuellen Seite.
     ---------------------------------------------------------------- */

  function openConsentBanner() {
    try {
      if (
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.showPreferences === 'function'
      ) {
        window.Shopify.customerPrivacy.showPreferences();
        return true;
      }
    } catch (e) {}

    /* Rueckfall: Anker auf der aktuellen Seite setzen. Shopifys Skript
       reagiert darauf und blendet das Banner wieder ein. */
    if (window.location.hash === '#shopifyReshowConsentBanner') {
      window.location.hash = '';
    }
    window.location.hash = 'shopifyReshowConsentBanner';
    return true;
  }

  /* ----------------------------------------------------------------
     Zentraler Klick-Handler
     ---------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href]') : null;
    if (!link) return;

    var raw = link.getAttribute('href') || '';

    /* Cookie-Einstellungen abfangen, egal welche Basis-URL davor steht */
    if (raw.indexOf('shopifyReshowConsentBanner') !== -1) {
      event.preventDefault();
      if (isInsideOverlay(link)) closeMenu(link);
      window.setTimeout(openConsentBanner, 120);
      return;
    }

    var url;
    try { url = new URL(link.href, window.location.href); } catch (e) { return; }

    if (!url.hash || url.hash === '#') return;
    if (url.host !== window.location.host) return;
    if (url.pathname !== window.location.pathname) return;

    var target = document.querySelector(url.hash);
    if (!target) return;
    if (!isInsideOverlay(link)) return;

    event.preventDefault();
    closeMenu(link);

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.setTimeout(function () {
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', url.hash);
      }
    }, 260);
  });

  /* ----------------------------------------------------------------
     2 - GALERIE NACH FARBE FILTERN

     Die Alt-Texte folgen dem Muster "<Produkt> in <Farbe>, <Seite>".
     Wir schneiden die Farbe exakt heraus und vergleichen sie
     vollstaendig mit der gewaehlten Option - kein Teilstring-Vergleich,
     sonst wuerde die Groesse "S" als Farbtreffer gelten.
     ---------------------------------------------------------------- */

  var scheduled = false;

  function colorFromAlt(alt) {
    if (!alt) return null;
    var at = alt.lastIndexOf(' in ');
    if (at === -1) return null;
    var rest = alt.slice(at + 4);
    var comma = rest.indexOf(',');
    if (comma === -1) return null;
    var value = rest.slice(0, comma).trim();
    return value.length ? value : null;
  }

  function selectedValues() {
    var radios = document.querySelectorAll('input[type="radio"]:checked');
    var chosen = [];
    Array.prototype.forEach.call(radios, function (r) {
      var v = (r.value || '').trim();
      if (v && chosen.indexOf(v) === -1) chosen.push(v);
    });
    return chosen;
  }

  function filterGallery() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var items = gallery.querySelectorAll('.media-gallery__grid > li, slideshow-slide');
    if (!items.length) return;

    var chosen = selectedValues();
    if (!chosen.length) return;

    var colors = [];
    Array.prototype.forEach.call(items, function (item) {
      var img = item.querySelector('img');
      var c = colorFromAlt(img ? img.getAttribute('alt') : '');
      if (c && colors.indexOf(c) === -1) colors.push(c);
    });
    if (colors.length < 2) return;

    var active = null;
    for (var i = 0; i < chosen.length; i++) {
      if (colors.indexOf(chosen[i]) !== -1) { active = chosen[i]; break; }
    }
    if (!active) return;

    Array.prototype.forEach.call(items, function (item) {
      var img = item.querySelector('img');
      var c = colorFromAlt(img ? img.getAttribute('alt') : '');
      item.style.display = c !== null && c !== active ? 'none' : '';
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      filterGallery();
    });
  }

  document.addEventListener('change', schedule);
  document.addEventListener('click', function () { window.setTimeout(schedule, 120); });

  if (window.MutationObserver) {
    var observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  schedule();
})();
